import styled from 'styled-components';

// Modal "Resumo do turno (IA)" — tokens CCO, fundo solido (sem
// backdrop-filter: nao renderiza bem no navegador da TV).

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

export const Panel = styled.div`
  background: var(--cco-surface);
  border: 1px solid var(--cco-line);
  border-radius: 14px;
  width: 100%;
  max-width: 560px;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--cco-line);
`;

export const Title = styled.h2`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: var(--cco-ink);

  > svg {
    color: var(--cco-cyan, var(--cco-blue));
    flex-shrink: 0;
  }
`;

export const AiTag = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--cco-blue-soft);
  color: var(--cco-blue);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
`;

export const HeaderRight = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

export const WindowToggle = styled.div`
  display: inline-flex;
  padding: 2px;
  gap: 2px;
  border-radius: 7px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line);
`;

export const WindowBtn = styled.button`
  padding: 4px 10px;
  border: none;
  border-radius: 5px;
  background: ${(props) => (props.$active ? 'var(--cco-blue)' : 'transparent')};
  color: ${(props) => (props.$active ? '#fff' : 'var(--cco-ink-mute)')};
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: background 150ms, color 150ms;
`;

export const Close = styled.button`
  background: transparent;
  border: 1px solid var(--cco-line);
  color: var(--cco-ink-mute);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  :hover {
    background: var(--cco-soft-surface);
    color: var(--cco-ink);
  }
`;

export const Body = styled.div`
  padding: 16px 18px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;

  scrollbar-width: thin;
  scrollbar-color: var(--cco-line-strong) transparent;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--cco-line-strong);
    border-radius: 3px;
  }
`;

export const Loading = styled.div`
  padding: 28px 0;
  text-align: center;
  color: var(--cco-ink-faint);
  font-size: 13px;
`;

export const Empty = styled.div`
  padding: 10px 0;
  color: var(--cco-ink-faint);
  font-size: 13px;
  line-height: 1.5;
`;

// Briefing do LLM — texto corrido, legivel de relance.
export const Summary = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: var(--cco-ink);
  white-space: pre-line;
`;

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Chip = styled.span`
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid var(--cco-line);
  background: var(--cco-soft-surface);
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${(props) =>
    props.$tone === 'red'
      ? 'var(--cco-red)'
      : props.$tone === 'ok'
      ? 'var(--cco-ink-mute)'
      : 'var(--cco-ink)'};
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-top: 1px solid var(--cco-line);
  padding-top: 12px;
`;

export const SectionLabel = styled.span`
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--cco-ink-faint);
`;

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
`;

export const RowName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: var(--cco-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RowMeta = styled.span`
  font-size: 11.5px;
  font-weight: 600;
  color: var(--cco-ink-mute);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

// === Copiloto (chat) ===
export const ChatMsg = styled.div`
  max-width: 88%;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-line;
  align-self: ${(props) => (props.$user ? 'flex-end' : 'flex-start')};
  background: ${(props) =>
    props.$user ? 'var(--cco-blue-soft)' : 'var(--cco-soft-surface)'};
  color: ${(props) =>
    props.$thinking ? 'var(--cco-ink-faint)' : 'var(--cco-ink)'};
  border: 1px solid
    ${(props) => (props.$user ? 'transparent' : 'var(--cco-line)')};
  font-style: ${(props) => (props.$thinking ? 'italic' : 'normal')};
`;

export const AskBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-top: 1px solid var(--cco-line);
`;

export const AskInput = styled.input`
  flex: 1;
  height: 38px;
  padding: 0 12px;
  border-radius: 9px;
  border: 1px solid var(--cco-line);
  background: var(--cco-soft-surface);
  color: var(--cco-ink);
  font-size: 13px;
  outline: none;
  transition: border-color 150ms, box-shadow 150ms;

  &::placeholder {
    color: var(--cco-ink-faint);
  }
  &:focus {
    border-color: var(--cco-blue);
    box-shadow: 0 0 0 2px var(--cco-blue-soft);
  }
  &:disabled {
    opacity: 0.6;
  }
`;

export const AskSend = styled.button`
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  border: none;
  background: var(--cco-blue);
  color: #fff;
  cursor: pointer;
  transition: filter 150ms;

  &:hover:not(:disabled) {
    filter: brightness(1.08);
  }
  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 18px;
  border-top: 1px solid var(--cco-line);
`;

export const FootNote = styled.span`
  font-size: 11px;
  color: var(--cco-ink-faint);
`;

export const Refresh = styled.button`
  height: 32px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid var(--cco-line);
  background: transparent;
  color: var(--cco-ink-mute);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;

  &:hover:not(:disabled) {
    color: var(--cco-ink);
    border-color: var(--cco-line-strong);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
